import { StyledContainer } from "./styles";
import { ContainerProps } from "../types";

const FullWidthContainer = ({ border, children }: ContainerProps) => (
  <StyledContainer border={border}>{children}</StyledContainer>
);

export default FullWidthContainer;
